import React, { useState } from "react";
import AddClassCard from "./AddClassCard";
import SelectClassesModal from "./SelectClassesModal";
import SelectedClassesList from "../SelectedClassesListStep";
import { CardItem } from "../SelectedClassesListStep/ClassCard";
import styles from "./style.module.scss";

interface AddClassesProps {
  selectedValues: string[];
  setSelectedValues: React.Dispatch<React.SetStateAction<string[]>>;
  options: { label: string; value: string }[];
  loading?: boolean;
  error?: any;
  progressLimit: number;
  selectedCard: string | null;
  onDelete: (value: string) => void;
  onItemDelete: (value: string, mediaId: string) => void;
  classItemsMap?: Record<string, CardItem[]>;
  setClassItemsMap?: React.Dispatch<
    React.SetStateAction<Record<string, CardItem[]>>
  >;
}

export interface SeedStepRef {
  handleOpenModal: () => void;
}

const SeedStep = React.forwardRef<SeedStepRef, AddClassesProps>(
  (
    {
      selectedValues,
      setSelectedValues,
      options,
      error,
      selectedCard,
      progressLimit,
      loading,
      onDelete,
      onItemDelete,
      classItemsMap,
      setClassItemsMap,
    },
    ref
  ) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [tempSelected, setTempSelected] = useState<string[]>([]);

    const handleOpenModal = () => {
      setTempSelected(selectedValues);
      setIsModalOpen(true);
    };

    const handleAdd = () => {
      setSelectedValues(tempSelected);
      setIsModalOpen(false);
      if (setClassItemsMap) {
        setClassItemsMap((prev) =>
          Object.fromEntries(
            Object.entries(prev).filter(([key]) => tempSelected.includes(key))
          )
        );
      }
    };

    // Expose handleOpenModal to parent via ref
    React.useImperativeHandle(ref, () => ({
      handleOpenModal,
    }));

    if (error) {
      return <div>Something went wrong.. </div>;
    }

    return (
      <div className={styles.seedStep}>
        <AddClassCard onClick={handleOpenModal} />

        <SelectClassesModal
          isModalOpen={isModalOpen}
          onCLose={() => setIsModalOpen(false)}
          options={options}
          selectedValues={tempSelected}
          setSelectedValues={setTempSelected}
          loading={loading}
          onAdd={handleAdd}
        />

        <SelectedClassesList
          selectedItems={options.filter((opt) =>
            selectedValues.includes(opt.value)
          )}
          onDelete={onDelete}
          selectedCard={selectedCard}
          progressLimit={progressLimit}
          onItemDelete={onItemDelete}
          classItemsMap={classItemsMap}
        />
      </div>
    );
  }
);

export default SeedStep;
